import { defineAsyncComponent } from 'vue';

const FAAdjustmentDetail = defineAsyncComponent(() => import('@/views/asset/faAdjustment/FAAdjustmentDetail.vue'));
const FAPurchaseIncrementDetail = defineAsyncComponent(() =>
  import('@/views/asset/fAPurchaseIncrement/FAPurchaseIncrementDetail.vue')
);
const FADecrementDetail = defineAsyncComponent(() => import('@/views/asset/fADecrement/FADecrementDetail.vue'));
const FAIncrementDetail = defineAsyncComponent(() => import('@/views/asset/fAIncrement/FAIncrementDetail.vue'));
const FASaleInvoiceDetail = defineAsyncComponent(() => import('@/views/asset/fASaleInvoice/FASaleInvoiceDetail.vue')); //Bán TSCĐ chưa thu tiền
const ApproveVoucherFAAdjustmentList = defineAsyncComponent(() =>
  import('@/views/asset/faAdjustment/ApproveVoucherFAAdjustmentList.vue')
);
const ApproveVoucherFASaleInvoiceList = defineAsyncComponent(() =>
  import('@/views/asset/fASaleInvoice/ApproveVoucherFASaleInvoiceList.vue')
);
const ApproveVoucherFAIncrementList = defineAsyncComponent(() =>
  import('@/views/asset/fAIncrement/ApproveVoucherFAIncrementList.vue')
);
const ApproveVoucherFADecrementList = defineAsyncComponent(() =>
  import('@/views/asset/fADecrement/ApproveVoucherFADecrementList.vue')
);
const FAInvoiceFixedAssetDetail = defineAsyncComponent(() =>
  import('@/views/asset/fAPurchaseIncrement/FAInvoiceFixedAssetDetail.vue')
);
const ApproveVoucherFAPurchaseIncrementList = defineAsyncComponent(() =>
  import('@/views/asset/fAPurchaseIncrement/ApproveVoucherFAPurchaseIncrementList.vue')
);
const FADepreciationDetail = defineAsyncComponent(() =>
  import('@/views/asset/fADepreciations/FADepreciationDetail.vue')
);
const FATransferDetail = defineAsyncComponent(() => import('@/views/asset/fATransfer/FATransferDetail.vue'));
const ApproveVoucherFATransferList = defineAsyncComponent(() =>
  import('@/views/asset/fATransfer/ApproveVoucherFATransferList.vue')
);
const CAReceiptFixedAssetDetail = defineAsyncComponent(() =>
  import('@/views/asset/fARevenue/CAReceiptFixedAssetDetail.vue')
);

const ApproveVoucherCAReceiptFixedAsset = defineAsyncComponent(() =>
  import('@/views/asset/fARevenue/ApproveVoucherCAReceiptFixedAsset.vue')
);
const FADevaluationDetail = defineAsyncComponent(() => import('@/views/asset/fADepreciations/FADevaluationDetail.vue'));
const ApproveVoucherFADevaluationList = defineAsyncComponent(() =>
  import('@/views/asset/fADepreciations/ApproveVoucherFADevaluationList.vue')
);

export function registerAsset(app) {
  app.component('FAAdjustmentDetail', FAAdjustmentDetail);
  app.component('FAPurchaseIncrementDetail', FAPurchaseIncrementDetail);
  app.component('FADecrementDetail', FADecrementDetail);
  app.component('FAIncrementDetail', FAIncrementDetail);
  app.component('FATransferDetail', FATransferDetail);
  app.component('ApproveVoucherFAIncrementList', ApproveVoucherFAIncrementList);
  app.component('ApproveVoucherFADecrementList', ApproveVoucherFADecrementList);
  app.component('FASaleInvoiceDetail', FASaleInvoiceDetail);
  app.component('ApproveVoucherFAAdjustmentList', ApproveVoucherFAAdjustmentList);
  app.component('ApproveVoucherFASaleInvoiceList', ApproveVoucherFASaleInvoiceList);
  app.component('FAInvoiceFixedAssetDetail', FAInvoiceFixedAssetDetail);
  app.component('FADepreciationDetail', FADepreciationDetail);
  app.component('ApproveVoucherFATransferList', ApproveVoucherFATransferList);
  app.component('CAReceiptFixedAssetDetail', CAReceiptFixedAssetDetail);
  app.component('ApproveVoucherCAReceiptFixedAsset', ApproveVoucherCAReceiptFixedAsset);
  app.component('FADevaluationDetail', FADevaluationDetail);
  app.component('ApproveVoucherFADevaluationList', ApproveVoucherFADevaluationList);
  app.component('ApproveVoucherFAPurchaseIncrementList', ApproveVoucherFAPurchaseIncrementList);
}
